<template>
  <div>
    <el-dialog
        :title="titleStr"
        :visible="isVisible"
        destroy-on-close
        lock-scroll
        close-on-press-escape
        width="80%"
        height="100%"
        :before-close="cacle"
    >
      <div v-if="type === 1 && url">
         <iframe :src="url" ref="frame" frameborder="0" width="100%" height="530px"></iframe>
      </div>
      <div class="wxcodebox" v-if="type === 2 && url">
        <div class="wxcode">
          <div><span style="color:#02ce0b">微信</span>扫码支付</div>
          <div v-html="url" style="width: 200px;height: 200px"></div>
          <div>使用<span style="color:#02ce0b">微信</span>扫码完成付款</div>
          <slot></slot>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'paycommon',
  props: {
    type: {
      type: Number,
      default: 1
    },
    order: {
      type: Object,
      default: function () {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isVisible: false,
      url: ''
    }
  },
  async activated () {
    this.isVisible = this.visible
    // await this.paycommon()
  },
   methods: {
    async paycommon () {
      this.order.type = this.type
      let url = await request({
        url: '/common/pay',
        method: "post",
        data: this.order
      })
      url && (this.url = url)
    },
    cacle (done) {
      done()
      this.$emit('cacle', false)
    }
  },
  watch: {
    visible: function (val, oldVal) {
      val && this.paycommon()
      this.isVisible = val
    },
    type: function (val, oldVal) {
      this.type = val
    }
  },
  computed: {
    titleStr () {
      return this.type === 1 ? '支付宝支付' : '微信支付'
    }
  }
}
</script>
<style scoped>
.wxcodebox{
   /* width: 100%; */
   display: flex;
   justify-content: center;
   align-items: center;
}
.wxcode{
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
